<script lang="ts" setup>
import { computed, inject } from "vue";
import { PIP_ATTACH_KEY } from "@/constants/pip";

const attach = inject(PIP_ATTACH_KEY, null);

const defaults = computed(() => ({ global: { attach: attach?.value ?? undefined } }));
</script>

<template>
  <v-defaults-provider :defaults="defaults">
    <slot></slot>
  </v-defaults-provider>
</template>
